import React, { useCallback, useRef, useState } from 'react';
import { usePullToRefresh } from '../../notifications/usePullToRefresh';
import './PullToRefresh.css';

// Generic pull-to-refresh wrapper for window-scrolled screens whose content
// components own their data fetching (including class components). The
// refresh remounts the children via a key bump - mount re-runs their fetch -
// which trades a brief skeleton for zero coupling to each screen's
// internals. The indicator matches the marketplace's.
const PullToRefresh = ({ children }) => {
  const containerRef = useRef(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const onRefresh = useCallback(async () => {
    setRefreshKey((k) => k + 1);
    // Give the remount a beat so the spinner doesn't blink out instantly.
    await new Promise((resolve) => setTimeout(resolve, 350));
  }, []);

  const ptr = usePullToRefresh(containerRef, onRefresh, { windowScroll: true });

  return (
    <div ref={containerRef} className="ptr-container">
      {(ptr.distance > 0 || ptr.refreshing) && (
        <div
          className={`ptr-indicator${ptr.refreshing ? ' spinning' : ''}`}
          style={{
            opacity: Math.min(1, ptr.progress * 1.2),
            transform: `translateX(-50%) translateY(${Math.min(ptr.distance * 0.6, 70)}px) rotate(${ptr.progress * 270}deg)`,
          }}
          aria-hidden
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" width="18" height="18">
            <path d="M21 12a9 9 0 1 1-3-6.7" />
            <polyline points="21 3 21 9 15 9" />
          </svg>
        </div>
      )}
      <React.Fragment key={refreshKey}>{children}</React.Fragment>
    </div>
  );
};

export default PullToRefresh;
